import { render, staticRenderFns } from "./ControlesBarChart.vue?vue&type=template&id=47ac19cc&scoped=true"
import script from "./ControlesBarChart.vue?vue&type=script&lang=js"
export * from "./ControlesBarChart.vue?vue&type=script&lang=js"
import style0 from "./ControlesBarChart.vue?vue&type=style&index=0&id=47ac19cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac19cc",
  null
  
)

export default component.exports